import { ChildLocation } from 'features/locations/location.types';
import { ReportableGeoEvent } from 'features/reports/components/ReportForm';

export const getChildLocations = (
  geoEvent?: ReportableGeoEvent,
): ChildLocation[] => {
  if (!geoEvent) return [];

  if (!('childGeoEvents' in geoEvent)) return [];

  return (geoEvent.childGeoEvents.filter(
    (ge) => ge.geoEventType === 'location' && ge.isActive,
  ) || []) as ChildLocation[];
};
